import React from 'react';
import Table from 'react-bootstrap/Table';
import { DateTime } from 'luxon';
import { Client } from '../../../../../../common/src/entities';

interface DynamicTableClientProps {
    data: Client;
    title: string;
}
const DynamicTableContact: React.FC<DynamicTableClientProps> = ({ data, title }) => {
    return (
        <div>
            <p>{title}</p>
            <Table striped bordered hover>
                <thead>
                    <tr>
                        <th>Téléphone:</th>
                        <th>Courriel:</th>
                        <th># moyen pédago:</th>
                        <th># moyen sorties:</th>
                        <th>Élèves Total:</th>
                        <th>Groupe Age:</th>
                    </tr>
                </thead>
                <tbody>
                    <td>{data.telephone}</td>
                    <td>{data.courriel}</td>
                    <td>{data.nb_avg_pedago}</td>
                    <td>{data.nb_avg_sortie}</td>
                    <td>{data.nb_eleves_total}</td>
                    <td>{data.groupe_age}</td>
                </tbody>
            </Table>
        </div>
    );
};

export default DynamicTableContact;
